// app/javascript/controllers/department_designation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["designationSelect"]

  load(event) {
    const departmentId = event.target.value
    if (!departmentId) return
    fetch(`/hris/employees/designation_by_department?department_id=${departmentId}`)
      .then(response => {
        if (!response.ok) throw new Error("Network error")
        return response.json()
      })
      .then(data => {
        this.designationSelectTarget.innerHTML = ""

        const defaultOption = document.createElement("option")
        defaultOption.value = ""
        defaultOption.text = "Select Designation"
        this.designationSelectTarget.appendChild(defaultOption)

        data.forEach(desig => {
          const option = document.createElement("option")
          option.value = desig.id
          option.text = `${desig.name}`
          this.designationSelectTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }
}
